import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isHeaderRow = function isHeaderRow(row) {
  return row.child(0).type.name === 'tableHeader';
};
var isHeaderRowPresent = function isHeaderRowPresent(table) {
  var headerRowPresent = false;
  table.content.forEach(function (row) {
    if (isHeaderRow(row)) {
      headerRowPresent = true;
    }
  });
  return headerRowPresent;
};
var renderNode = function renderNode(state, node, index) {
  if (index > 0) {
    state.write(' ');
  }
  node.content.forEach(function (child, i) {
    if (child.isTextblock || child.type.name === 'mediaSingle') {
      if (i > 0) {
        state.write(' ');
      }
      state.context.insideTable = true;
      state.renderInline(child);
      state.context.insideTable = false;
    } else {
      renderNode(state, child, i);
    }
  });
};
var renderInlineContent = function renderInlineContent(state, node, _parent, _index, options) {
  options.headerRowPresent && state.write('| ');
  renderNode(state, node, 0);
  state.write(' ');
};
export default {
  table: function table(state, node) {
    var headerRowPresent = isHeaderRowPresent(node);
    node.content.forEach(function (child, i) {
      try {
        state.render(child, node, i, {
          headerRowPresent: headerRowPresent,
          skipFallback: true
        });
      } catch (error) {
        state.updateFallbackState(error, node);
        state.nodes.fallback(state, node);
      }
    });
    state.closeBlock(node);
  },
  tableRow: function tableRow(state, node, _parent, _index, options) {
    node.content.forEach(function (child, i) {
      try {
        state.render(child, node, i, _objectSpread(_objectSpread({}, options), {}, {
          skipFallback: true
        }));
      } catch (error) {
        state.updateFallbackState(error, node);
        state.nodes.fallback(state, node);
      }
    });
    if (options.headerRowPresent) {
      state.write('|');
      state.ensureNewLine();
      if (isHeaderRow(node)) {
        for (var i = 0; i < node.childCount; i++) {
          state.write('| --- ');
        }
        state.write('|');
        state.ensureNewLine();
      }
    }
  },
  tableHeader: function tableHeader(state, node, _parent, _index, options) {
    renderInlineContent(state, node, _parent, _index, options);
  },
  tableCell: function tableCell(state, node, _parent, _index, options) {
    renderInlineContent(state, node, _parent, _index, options);
  }
};